import { render } from "./DentalTourismPage.vue?vue&type=template&id=c05c4e80"
import script from "./DentalTourismPage.vue?vue&type=script&lang=js"
export * from "./DentalTourismPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__